import {
  CompanyCircleAvatar,
  CompanyInfoContent,
  CompanyInfoGridChild,
  EmptyBlueHeader,
} from "../styles/Boleto";

export const CompanyInfo = ({ companyName, companyCnpj, companyLogoUrl }) => (
  <CompanyInfoGridChild>
    <EmptyBlueHeader />
    <CompanyInfoContent>
      <CompanyCircleAvatar
        style={{
          top: "15%",
        }}
      >
        <img src={companyLogoUrl} alt="" />
      </CompanyCircleAvatar>
      <div>
        <p
          style={{
            color: "#004bff",
            fontWeight: "bold",
          }}
        >
          {companyName}
        </p>
        <p>
          {companyCnpj.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          )}
        </p>
      </div>
    </CompanyInfoContent>
  </CompanyInfoGridChild>
);
